import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor() { }

  public async set(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  public async get(key: string){
    return localStorage.getItem(key);
  }

  public async remove(key: string) {
    localStorage.removeItem(key);
  }

  public async clear(){
    localStorage.clear();
  }
}
